export default {"src":"/_next/static/media/italic_regular.fb53a52a.svg","height":24,"width":24};